const addressForm = document.getElementById('address-form')

if (addressForm) {
  addressForm.noValidate = true

  addressForm.addEventListener('submit', (event) => {
    if (validateAll()) {
      return true
    } else {
      event.preventDefault()
    }
  })

  const orderZipCodeInput = document.getElementById('order_zipcode')
  const delZipCodeInput = document.getElementById('del_zipcode')

  ;[orderZipCodeInput, delZipCodeInput].forEach((input) => {
    if (input) {
      input.addEventListener('input', (event) => {
        event.target.value = event.target.value.toUpperCase()
      })
    }
  })

  const phoneNumberInput = document.getElementById('phonenumber')
  const phoneInput = document.getElementById('phone')
  const phonePrefixSelect = document.getElementById('phoneprefix')

  function setPhoneInputValue() {
    phoneInput.value = phonePrefixSelect.value + phoneNumberInput.value
  }

  if (phoneNumberInput) {
    phoneNumberInput.addEventListener('input', (event) => {
      event.target.value = event.target.value.replace(/\D/g, '')
      setPhoneInputValue()
    })

    phonePrefixSelect.addEventListener('change', (event) => {
      setPhoneInputValue()
    })
  }
}

const addError = (element) => {
  if (!element.classList.contains('error')) {
    element.classList.add('input--error')

    const parent = element.parentNode
    if (parent.classList.contains('input-group')) {
      parent.parentNode.classList.add('input-wrapper--error')
    } else {
      element.parentNode.classList.add('input-wrapper--error')
    }
  }
}

const removeError = (element) => {
  element.classList.remove('input--error')

  const parent = element.parentNode
  if (parent.classList.contains('input-group')) {
    parent.parentNode.classList.remove('input-wrapper--error')
  } else {
    element.parentNode.classList.remove('input-wrapper--error')
  }
}

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

document.querySelectorAll('#address-form [required]').forEach((input) => {
  input.addEventListener('blur', (event) => {
    validateField(event.target)
  })
})

const validateAll = () => {
  document.querySelectorAll('#address-form [required]').forEach((input) => {
    validateField(input)
  })

  const errors = document.getElementsByClassName('input--error')

  if (errors.length) {
    errors[0].focus()
    return false
  } else {
    return true
  }
}

const twoWordsRegexp = new RegExp(
  /[a-zA-ZÆØÅæøåÜÖÄŸÉÑüöäÿéñ]+\s+[a-zA-ZÆØÅæøåÜÖÄŸÉÑüöäÿéñ]+/g
)
// const wordAndNumberRegexp = new RegExp(/(.*)+\s+[0-9]+/g)
const wordAndNumberRegexp = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])/)

// Force format: 4 digits and 2 letters seperated by a whitespace - for example: 1000 AP
const nlZipcodeRegexp = new RegExp(/^[1-9][0-9]{3}\s+?[a-zA-Z]{2}$/)

const validateField = (input) => {
  // Don't validate invisible fields
  if (input.offsetParent === null) {
    input.value = ''
    removeError(input)
    return
  }

  if (input.getAttribute('type') === 'text') {
    twoWordsRegexp.lastIndex = 0
    wordAndNumberRegexp.lastIndex = 0
    nlZipcodeRegexp.lastIndex = 0

    if (!input.value) {
      addError(input)
    } else if (
      input.getAttribute('data-validation') == '2-words' &&
      !twoWordsRegexp.test(input.value)
    ) {
      addError(input)
    } else if (
      input.getAttribute('data-validation') == 'word-and-number' &&
      !wordAndNumberRegexp.test(input.value)
    ) {
      addError(input)
    } else if (
      input.getAttribute('data-validation') == 'nl-zipcode' &&
      !nlZipcodeRegexp.test(input.value)
    ) {
      addError(input)
    } else {
      removeError(input)
    }
  } else if (input.getAttribute('type') === 'email') {
    if (!input.value || !validateEmail(input.value)) {
      addError(input)
    } else if (input.getAttribute('name') === 'email-repeat') {
      var emails = []
      addressForm.querySelectorAll('input[type=email]').forEach((email) => {
        emails.push(email.value)
      })

      if (emails.every((val, i, arr) => val === arr[0])) {
        removeError(input)
      } else {
        addError(input)
      }
    } else {
      removeError(input)
    }
  } else if (input.getAttribute('type') === 'checkbox') {
    if (!input.checked) {
      addError(input)
    } else {
      removeError(input)
    }
  }

  if (input.classList.contains('input--error')) {
    if (input.getAttribute('listener') !== 'true') {
      input.addEventListener('input', (event) => validateField(event.target))
      input.setAttribute('listener', 'true')
    }
  } else {
    input.setAttribute('listener', 'false')
    input.removeEventListener('input', (event) => validateField(event.target))
  }
}

const alternativeDelivery = document.getElementById('alternative-delivery')

if (alternativeDelivery) {
  const checkDeliveryChecked = () => {
    setTimeout(() => {
      const addressBox = document.querySelector('.address__alternative')

      if (alternativeDelivery.checked) {
        addressBox.classList.add('address__alternative--active')
      } else {
        addressBox.classList.remove('address__alternative--active')
      }
    })
  }

  checkDeliveryChecked()

  alternativeDelivery.addEventListener('change', (event) => {
    checkDeliveryChecked()
  })
}
